<template>
  <div :style="mocolor">
    <div class="change-time">
      <select name="hours" class="select-css" :value="hoursData" @change="changeHour">
        <option
          v-for="(hour, idx) in 24"
          :key="idx"
          :value="idx"
        >{{ get2Digits(idx) }}</option>
      </select>
      <p class="time-separator">:</p>
      <select name="minutes" class="select-css" :value="minutesData" @change="changeMinute">
        <option
          v-for="(minute, idx) in 60"
          :key="idx"
          :value="idx"
        >{{ get2Digits(idx) }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hoursData: {
      type: Number,
      default: 8,
    },
    minutesData: {
      type: Number,
      default: 0,
    },
    fontColor: {
      type: String,
      default: '#000000',
    },
  },
  data() {
    return {
      hours: 0,
      minute: 0,
    };
  },
  watch: {
    hoursData(nVal) {
      this.hours = nVal;
    },
    hours(nVal) {
      console.log('hours nVal: ', nVal);
    },
    minute(nVal) {
      console.log('minute nVal: ', nVal);
    },
  },
  computed: {
    mocolor() {
      return {
        '--main-color': this.fontColor,
      };
    },
  },
  methods: {
    get2Digits(num) {
      return num < 10 ? `0${num}` : num;
    },
    changeHour(evt) {
      console.log('changeHour evt: ', evt.target.value);
      this.$emit('changeHour', evt.target.value);
    },
    changeMinute(evt) {
      console.log('changeMinute evt: ', evt.target.value);
      this.$emit('changeMinute', evt.target.value);
    },
  },
};
</script>

<style scoped>
  .change-time {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 3em 0 3em;
  }

  .select-css {
    font-size: 32px;
    font-weight: bold;
    color: var(--main-color);
    margin: 0;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-color: transparent;
    border: none;
    text-align: center;
  }

  .select-css::-ms-expand {
    display: none;
  }

  .select-css:focus {
    color: #000000;
    outline: none;
  }

  .select-css option {
    font-weight:normal;
  }

  .time-separator {
    padding: 0 12px 0 12px;
    font-size: 32px;
    margin: 0;
  }
</style>
